<main id="main-content" tabindex="-1" aria-label="District Management">
  <div class="max-h-fit px-0 md:px-4 lg:px-20 pt-10">
     <div class="grid grid-cols-2 py-5">
      <div class="col-span-2 lg:col-span-1 items-center pb-4">
        <h1 class="text-dark-purple text-3xl font-bold">Districts</h1>
      </div>
        <div class="col-span-2 pb-4 flex flex-col md:flex-row md:justify-end">
        @if (!isDistrictAdmin) {
            <prism-btn
                btnClass="bg-white text-dark-purple font-bold border-2 p-0 m-0 rounded-xl border-dark-purple"
                (click)="addDistrict()">
                  <i class="uil uil-plus text-dark-purple font-bold pr-1"></i>Add District
            </prism-btn>
          }
        </div>
          <div class="col-span-2 grid grid-cols-1 lg:grid-cols-12 gap-4 pb-4 items-start">
            <div class="lg:col-span-5">
              <prism-input
                inputType="text"
                [control]="searchForm.get('search')"
                [required]="false"
                placeHolder="Search districts"
                [hasSearch]="true"
                (search)="getDistricts()">
              </prism-input>
            </div>

            <div class="hidden lg:block lg:col-span-3"></div>

            <div class="lg:col-span-4 lg:col-start-9 w-full">
              <prism-select-organization
                [control]="districtId"
                [required]="false">
              </prism-select-organization>
            </div>
          </div>

      </div>
      <div>
          <prism-table [columns]="columns"
              [colHeaders]="colHeaders"
              [tableData]="data"
              [isDelete]="true"
              [isEdit]="true"
              [pageIndex]="pageIndex"
              [pageSize]="pageSize"
              [totalData]="totalData"
              (edit)="editDistrict($event)"
              (pageIndexChange)="handlePageIndexChange($event)"
              (pageSizeChange)="handlePageSizeChange($event)"
              (delete)="deleteDistrict($event)"
              (navigate)="navigate($event)"
              [hideActionBtns]="isDistrictAdmin"
              (columnDirectionChange)="handleColumnDirectionChange($event)">
          </prism-table>
      </div>
  </div>
</main>
<nz-modal
  [(nzVisible)]="isAddEditDistrict"
  [nzTitle]="modalTitle"
  nzOkText="Save"
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleSave()"
  [nzOkDisabled]="districtForm.pristine">
  <ng-container *nzModalContent>
    <form [formGroup]="districtForm" class="grid gap-4">
        <prism-input
          [control]="name"
          label="District Name"
          placeHolder="District Name"
          [required]="true"
          [inputType]="InputType.Text">
        </prism-input>
        <div class="col-span-1">
          <prism-select-county
            [control]="countyId"
            [required]="true"
            label="County"
            [readOnly]="isDistrictAdmin">
          </prism-select-county>
        </div>
    </form>
  </ng-container>
</nz-modal>
